import React, { memo } from 'react'
import { Page, Text, View, Document, StyleSheet, Svg, Path, Font } from '@react-pdf/renderer'
import { format } from 'date-fns'

import LegalEntityGeoprocessingMapDemarcationReportIndicatorPdf from './legalEntityGeoprocessingMapDemarcationReportIndicatorPdf.component'
import LegalEntityGeoprocessingMapDemarcationReportListPdf, {
  CityProps,
} from './legalEntityGeoprocessingMapDemarcationReportListPdf.component'
import LegalEntityGeoprocessingMapDemarcationReportDemographicAndEconomicPdf from './legalEntityGeoprocessingMapDemarcationReportDemographicAndEconomicPdf.component'
import LegalEntityGeoprocessingMapDemarcationReportMapPdf from './legalEntityGeoprocessingMapDemarcationReportMapPdf.component'
import { DemarcationFeature, FeatureProps } from '../../fetchFromDatabase/mapDemarcationReport.hook'
import { formatAsBrNumber } from '~/prix'

Font.register({
  family: 'Lato-700',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh6UVew-FGC_p9dw.ttf',
    },
  ],
})

Font.register({
  family: 'Lato-900',
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/lato/v24/S6u9w4BMUTPHh50Xew-FGC_p9dw.ttf',
    },
  ],
})

const Logo = () => (
  <Svg width='50' height='50' viewBox='0 0 185 99'>
    <Path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M102.282 39.3021L100.63 46.9516H103.974C105.88 46.9516 107.127 46.8657 107.715 46.6938C109.407 46.2015 110.447 45.0217 110.836 43.1464C110.924 42.7401 110.971 42.3807 110.971 42.0681C110.971 40.857 110.376 40.0522 109.184 39.6459C108.469 39.4193 107.278 39.3021 105.618 39.3021H102.282ZM131.576 52.8039H140.313L139.018 39.771H138.883L131.576 52.8039ZM68.818 51.5694L67.2135 59.0157H72.162C75.228 59.0157 77.0231 57.7968 77.5553 55.359C77.6427 54.9839 77.6903 54.6323 77.6903 54.312C77.6903 52.4836 76.2923 51.5694 73.4964 51.5694H68.818ZM71.5345 39.0287L70.0174 45.9983H74.2113C75.784 45.9983 76.8563 45.8655 77.4202 45.6077C78.6673 44.9982 79.4378 43.9825 79.7396 42.5604C80.0097 41.3415 79.7952 40.4117 79.1121 39.771C78.5799 39.2787 77.6744 39.0287 76.3956 39.0287H71.5345ZM57.2689 64.7587L64.0602 33.4576H81.4791C82.0351 33.5045 82.5117 33.5592 82.9089 33.6217C84.9581 33.9967 86.5229 34.7547 87.5873 35.8876C88.5643 36.9346 89.0567 38.1926 89.0567 39.6772C89.0567 40.2007 88.9932 40.7398 88.882 41.2868C88.0797 44.9123 85.2679 47.2954 80.4545 48.4284L80.4068 48.5143C84.6007 49.2722 86.6977 51.2178 86.6977 54.351C86.6977 56.3279 86.1337 58.1172 85.0058 59.7268C83.8779 61.3363 82.3687 62.5787 80.4783 63.4538C78.5879 64.3211 75.5934 64.7587 71.4948 64.7587H57.2689ZM0.309776 54.5933H9.13443C9.01528 55.148 8.95968 55.6012 8.95968 55.9606C8.95968 58.1406 10.453 59.2267 13.4395 59.2267C16.5691 59.2267 18.4039 58.0937 18.9281 55.8356C18.9837 55.5621 19.0155 55.2965 19.0155 55.0543C19.0155 54.0307 18.2847 53.3275 16.8153 52.9446L9.48392 51.0459C5.3218 49.9676 3.24868 47.8892 3.24868 44.8029C3.24868 44.1934 3.32017 43.5449 3.47108 42.8573C4.08269 40.2085 5.62363 38.0442 8.08596 36.3643C10.866 34.4656 14.488 33.5123 18.9361 33.5123C26.3786 33.5123 30.096 35.7704 30.096 40.2945C30.096 41.0367 29.9768 41.9509 29.7465 43.0214H20.8186C20.9615 42.4666 21.041 42.0056 21.041 41.6149C21.041 39.7944 19.8972 38.888 17.6175 38.888C16.3546 38.888 15.2744 39.1849 14.3689 39.7788C13.4634 40.3726 12.9232 41.1227 12.7405 42.0291C12.6849 42.2791 12.6532 42.5135 12.6532 42.7323C12.6532 43.8652 13.519 44.6466 15.2426 45.092L20.8186 46.5375C23.2491 47.1704 24.9489 47.8033 25.91 48.4362C27.5542 49.4832 28.3723 50.999 28.3723 52.9837C28.3723 53.6478 28.285 54.3588 28.1102 55.1324C27.4033 58.3281 25.5208 60.766 22.4469 62.4537C19.6351 64.0008 16.1401 64.7665 11.9462 64.7665C6.52913 64.7665 2.95479 63.5788 1.23116 61.2113C0.413035 60.1018 0 58.7501 0 57.1561C0 56.4919 0.103259 55.6403 0.309776 54.5933ZM29.2937 64.7587L36.1167 33.5592H60.2872L58.9925 39.5365H43.6546L42.2249 46.0374H56.6732L55.3388 52.0148H40.8905L39.4607 58.6876H55.1561L53.8217 64.7509H29.2937V64.7587ZM154.006 64.7587L160.829 33.5592H185L183.705 39.5365H168.367L166.938 46.0374H181.386L180.052 52.0148H165.603L164.174 58.6876H179.869L178.534 64.7509H154.006V64.7587ZM68.9451 10.6342H127.39L129.566 0H71.1135L68.9451 10.6342ZM65.3707 27.1443H123.815L125.992 16.51H67.5471L65.3707 27.1443ZM53.6787 81.8547H112.123L114.3 71.2205H55.855L53.6787 81.8547ZM50.1043 98.3647H108.549L110.725 87.7305H52.2807L50.1043 98.3647ZM115.745 64.7587L135.269 33.7076H146.151L152.037 64.7665H141.957L141.107 58.5313H128.224L124.657 64.7665L115.745 64.7587H106.071C106.007 63.6023 106.174 61.2582 106.563 57.7109C106.682 56.4685 106.746 55.6246 106.746 55.1636C106.746 54.2104 106.5 53.5384 106.007 53.1556C105.515 52.7649 104.561 52.5695 103.132 52.5695H99.3826L96.7058 64.7587H87.7461L94.5691 33.5514H109.462C112.02 33.5514 113.712 33.6061 114.546 33.7233C116.563 34.0124 118.009 34.7 118.875 35.8017C119.677 36.7784 120.082 38.0051 120.082 39.474C120.082 40.2241 119.995 41.0133 119.812 41.8494C119.216 44.5294 117.802 46.4594 115.578 47.6392C114.125 48.4127 112.369 48.9519 110.32 49.241L110.272 49.4129C112.592 49.4676 114.164 49.9207 114.998 50.749C115.713 51.4444 116.071 52.6086 116.071 54.2495C116.071 54.7964 116.023 55.734 115.936 57.0623C115.658 60.9222 115.602 63.4851 115.745 64.7587Z'
      fill='#005EB8'
    />
  </Svg>
)

const styles = StyleSheet.create({
  body: {
    paddingTop: 20,
    paddingBottom: 42,
    paddingHorizontal: 40,
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 12,
    height: 50,
    textAlign: 'center',
    color: 'grey',
    borderBottom: '2px solid #005EB8',
  },

  logo: {
    display: 'flex',
    width: '20%',
    height: 50,
    justifyContent: 'flex-start',
    paddingLeft: '10px',
  },

  headerTextContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    width: '80%',
    height: 50,
    paddingRight: '10px',
  },

  headerText: {
    fontSize: '13px',
    color: '#0F438A',
    fontFamily: 'Lato-700',
  },

  mapHeaderWrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: '12.5%',
  },

  mapTitleContainer: {
    display: 'flex',
    width: '50%',
    justifyContent: 'center',
    paddingRight: 60,
    paddingLeft: 20,
  },

  mapTitle: {
    fontSize: '15px',
    color: '#0F438A',
    fontFamily: 'Lato-700',
  },

  mapDescriptionContainer: {
    display: 'flex',
    width: '50%',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingLeft: 70,
    paddingTop: 15,
  },

  mapDescriptionText: {
    fontSize: '11px',
    color: '#0F438A',
    lineHeight: 1.5,
    textAlign: 'left',
  },

  mapDescriptionTextBold: {
    color: '#0F438A',
    fontFamily: 'Lato-900',
  },

  mapTextContainer: {
    display: 'flex',
    height: '57.5%',
    flexDirection: 'column',
  },

  mapTextTitle: {
    paddingTop: 20,
    paddingLeft: 20,
    fontSize: '15px',
    color: '#0F438A',
    paddingBottom: 10,
    fontFamily: 'Lato-700',
  },

  mapText: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 15,
    fontSize: '11px',
    lineHeight: 1.5,
    color: '#000',
    textAlign: 'justify',
  },

  footerAbsolute: {
    position: 'absolute',
    bottom: 25,
    left: 35,
    right: 35,
    borderTop: '2px solid #005EB8',
  },

  footerFlex: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 5,
  },

  footerUrl: {
    display: 'flex',
    width: '33%',
    fontSize: 11,
    textAlign: 'left',
    color: '#005EB8',
    paddingLeft: 10,
  },

  footerNumberPage: {
    display: 'flex',
    width: '33%',
    fontSize: 11,
    textAlign: 'center',
    color: '#005EB8',
    alignItems: 'center',
    justifyContent: 'center',
  },

  footerDate: {
    display: 'flex',
    width: '33%',
    fontSize: 11,
    textAlign: 'right',
    color: '#005EB8',
    paddingRight: 10,
  },
})

interface Feature {
  bbox: number[]
  features: FeatureProps[]
  geometry: {
    type?: string
  }
  properties?: {
    radius?: DemarcationFeature
    level?: string
  }
  isEnabled?: boolean
}

interface FeatureArray {
  geometry?: {
    type?: string
  }
  features: Feature[]
}

export interface ReportPdf {
  values: {
    result: {
      area: number | string
      averageCost?: {
        value: string
        legalEntityCount: number
      }
      revenue?: {
        value: string
        legalEntityCount: number
      }
      cnae: Array<{
        description: string
        count: number
      }>
      currentYear: number
      feature: Feature | FeatureArray
      firstHeaderAreaContent: {
        title: string
        subtitle: string
      }
      indicators: {
        legalEntityCount: number
        values?: Array<{
          name: string
          count: number | null
        } | null>
      }
      legalEntityAttendanceCount: string | number
      legalEntityCount: number
      legalEntitySizeCount: {
        micro: string | number | null
        small: string | number | null
        other: string | number | null
      }
      legalNature: Array<{
        description: string
        count: number
      }>
      segment: Array<{
        description: string
        count: number
      }>
      text: {
        firstParagraph: string
        secondParagraph: string
        thirdParagraph: string
        fourthParagraph: string
      }
      imageUrl: string[] | null
      citiesCensus: {
        data: any
        name: string
        intersectionArea: any
      }[]
      citiesGovernmentTransparency: any
      selectedYearChart: string
    }
  }
}

function legalEntityGeoprocessingMapDemarcationReportPdf(values: ReportPdf) {
  const { values: data } = values

  const selectedYearChart = data.result ? data.result.selectedYearChart : ''

  const isPolygon = data.result.feature ? data.result.feature.geometry?.type === 'Polygon' : false
  const isMultiPolygon =
    data.result.feature && data.result.feature?.features?.length > 0
      ? data.result.feature?.features[0]?.geometry?.type === 'MultiPolygon'
      : false
  const isRadius = data.result.feature ? data.result.feature.geometry?.type === 'Point' : false
  const isPointWithoutRadius =
    data.result.feature && data.result.feature?.features?.length > 0
      ? data.result.feature?.features[0]?.geometry?.type === 'Point' &&
        data.result.feature?.features[0]?.properties?.level === 'neighborhood'
      : false

  const currentDate = format(new Date(), 'dd/LL/yyyy')
  const locationType = data.result.firstHeaderAreaContent.title.toLowerCase()
  const locations = data.result.firstHeaderAreaContent.subtitle
  const area = data.result.area

  const averageRevenue = {
    value: data.result.revenue?.value,
    legalEntityCount: data.result.revenue?.legalEntityCount,
  }

  const averageCost = {
    value: data.result.averageCost?.value,
    legalEntityCount: data.result.averageCost?.legalEntityCount,
  }

  const citiesCensus = data.result?.citiesCensus
  const isNeighborhood =
    data.result.feature?.features?.length > 0
      ? data.result.feature.features[0]?.properties?.level === 'neighborhood'
      : undefined

  const citiesCensusCagedImageMerged = citiesCensus?.map(
    (census: { data: any; name: string; intersectionArea: any }, index: number | string) => {
      const getPropertyValue = (
        data: string | any[],
        key: string,
        dataIndex: number,
        defaultValue: string,
      ) =>
        data?.length > dataIndex && data[dataIndex].key === key
          ? data[dataIndex].value
          : defaultValue

      const getPropertyYear = (data: string | any[], key: string, dataIndex: number) =>
        data?.length > dataIndex && data[dataIndex].key === key ? data[dataIndex].year : null

      const properties = [
        { key: 'area', description: 'Área em Km²' },
        { key: 'grossDomesticProduct', description: 'PIB em Mil' },
        { key: 'population', description: 'Contagem Populacional' },
        { key: 'populationEstimative', description: 'Estimativa Populacional' },
        { key: 'populationDensity', description: 'Densidade Populacional' },
        { key: 'incomePerCapita', description: 'Renda per capita' },
        { key: 'lifeExpectancyAtBirth', description: 'Esperança de vida ao nascer' },
        { key: 'hdi', description: 'Índice de desenvolvimento humano' },
        { key: 'hdiIncome', description: 'IDHM de renda' },
        { key: 'hdiEducation', description: 'IDHM de educação' },
        { key: 'hdiLifeExpectancy', description: 'IDHM de expectativa de vida' },
        { key: 'hdiEducationAttendancy', description: 'Subíndice de frequência escolar' },
        { key: 'hdiEducationLevel', description: 'Subíndice de escolaridade' },
      ]

      const dataProperties = properties.map((property, dataIndex) => ({
        key: property.key,
        value: getPropertyValue(census.data, property.key, dataIndex, 'Sem informação'),
        year: getPropertyYear(census.data, property.key, dataIndex),
        description: property.description,
      }))

      return {
        name: census.name,
        intersectionArea: census.intersectionArea,
        data: dataProperties,
        chartImage: data.result?.imageUrl ? data.result?.imageUrl[index] : null,
        dataTransparency:
          data.result?.citiesGovernmentTransparency?.length > 0
            ? data.result?.citiesGovernmentTransparency[index].data
            : [],
      }
    },
  )

  return (
    <Document>
      <Page size='A4' style={styles.body}>
        <View style={styles.header} fixed>
          <View style={styles.logo}>
            <Logo />
          </View>
          <View style={styles.headerTextContainer}>
            <Text style={styles.headerText}>Relatório Demográfico e Socioeconômico de área</Text>
          </View>
        </View>

        <View style={styles.mapHeaderWrapper}>
          <View style={styles.mapTitleContainer}>
            <Text style={styles.mapTitle}>Relatório Demográfico e Socioeconômico</Text>
          </View>
          <View style={styles.mapDescriptionContainer}>
            <Text style={styles.mapDescriptionText}>Localização por {locationType}:</Text>
            <Text style={styles.mapDescriptionText}>
              <Text style={styles.mapDescriptionTextBold}>{locations}</Text>
            </Text>
            {area ? (
              <Text style={styles.mapDescriptionText}>
                Área de abrangência:
                <Text style={styles.mapDescriptionTextBold}>{area} km²</Text>
              </Text>
            ) : null}
          </View>
        </View>

        {data.result.feature ? (
          <LegalEntityGeoprocessingMapDemarcationReportMapPdf
            feature={data.result.feature}
            isPolygon={isPolygon}
            isMultiPolygon={isMultiPolygon}
            isRadius={isRadius}
            isPointWithoutRadius={isPointWithoutRadius}
          />
        ) : null}

        <View style={styles.mapTextContainer}>
          <Text style={styles.mapTextTitle}>Descritivo</Text>
          <Text style={styles.mapText}>{data.result.text.firstParagraph}</Text>
          {averageRevenue?.value !== '' && averageCost.value !== '' ? (
            <Text style={styles.mapText}>{data.result.text.secondParagraph}</Text>
          ) : null}
          <Text style={styles.mapText}>{data.result.text.thirdParagraph}</Text>
          <Text style={styles.mapText}>{data.result.text.fourthParagraph}</Text>
        </View>

        <LegalEntityGeoprocessingMapDemarcationReportDemographicAndEconomicPdf values={data} />

        <LegalEntityGeoprocessingMapDemarcationReportListPdf
          values={{
            cnae: data.result.cnae,
          }}
          type={'cnae'}
          title={'Atividade econômica principal'}
          subtitle={
            'Quantitativo de empresas por atividade econômica principal presentes na área demarcada.'
          }
        />

        {data.result.indicators?.values !== undefined ? (
          <LegalEntityGeoprocessingMapDemarcationReportIndicatorPdf
            values={data.result?.indicators}
          />
        ) : null}

        <LegalEntityGeoprocessingMapDemarcationReportListPdf
          values={{
            segment: data.result.segment,
          }}
          type={'segment'}
          title={'Empresas por segmento'}
          subtitle={'Quantitativo de empresas segmento presentes na área demarcada.'}
        />

        <LegalEntityGeoprocessingMapDemarcationReportListPdf
          values={{
            legalNature: data.result.legalNature,
          }}
          type={'legalNature'}
          title={'Empresas por natureza jurídica'}
          subtitle={'Quantitativo de empresas por natureza jurídica presentes na área demarcada.'}
        />

        {citiesCensusCagedImageMerged?.map(
          (
            item: {
              name: string
              intersectionArea: number | null
              data: CityProps[]
              chartImage: string | undefined
              dataTransparency: any
            },
            index: number,
          ) => (
            <React.Fragment key={index}>
              <LegalEntityGeoprocessingMapDemarcationReportListPdf
                title={item.name}
                subtitle={
                  area && (isNeighborhood === false || isNeighborhood === undefined)
                    ? `Intersecção de ${
                        item?.intersectionArea !== null
                          ? formatAsBrNumber(
                              parseFloat((Number(item?.intersectionArea) / 1000000).toFixed(2)),
                            )
                          : item?.data?.length > 0
                          ? formatAsBrNumber(item?.data[0]?.value)
                          : ''
                      } km²`
                    : undefined
                }
                type={'city'}
                chartImage={item.chartImage}
                values={{
                  city: item?.data,
                  dataTransparency: item?.dataTransparency,
                }}
              />
            </React.Fragment>
          ),
        )}

        <View style={styles.footerAbsolute} fixed>
          <View style={styles.footerFlex}>
            <Text style={styles.footerUrl}>www.prixsebrae.com</Text>
            <View style={styles.footerNumberPage}>
              <Text
                style={styles.footerNumberPage}
                render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
              />
            </View>
            <Text style={styles.footerDate}>{currentDate}</Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}

export default memo(legalEntityGeoprocessingMapDemarcationReportPdf)
